/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Details" |
*
* @param {Feedback_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_description_label = /** @type {((inputs?: Feedback_Description_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Description_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détails")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Detalhes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dettagli")
	return /** @type {LocalizedString} */ ("Details")
});